exports.components = {
  "component---src-layouts-layout-js": () => import("./../../../src/layouts/layout.js" /* webpackChunkName: "component---src-layouts-layout-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

